import React, { useState } from 'react';
import './GameJoin.css';

function GameJoin({ onJoin }) {
  const [gameCode, setGameCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const code = gameCode.toUpperCase().trim();

    if (code.length < 3 || code.length > 10) {
      setError('Game code must be 3-10 characters');
      return;
    }

    if (!/^[A-Z0-9]+$/.test(code)) {
      setError('Game code must contain only letters and numbers');
      return;
    }

    onJoin(code);
  };

  return (
    <div className="game-join-container">
      <div className="game-join-card">
        <h1>Join Game</h1>
        <p className="game-join-subtitle">Enter the game code to join</p>

        <form onSubmit={handleSubmit} className="game-join-form">
          <input
            type="text"
            className="game-code-input"
            placeholder="TAMIL or ABC123"
            value={gameCode}
            onChange={(e) => setGameCode(e.target.value.toUpperCase())}
            maxLength={10}
            autoFocus
          />

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="join-button">
            Join Game
          </button>
        </form>
      </div>
    </div>
  );
}

export default GameJoin;
